import { render, staticRenderFns } from "./CollinsTrackerMenu.vue?vue&type=template&id=1055047d&scoped=true&"
import script from "./CollinsTrackerMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./CollinsTrackerMenu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1055047d",
  null
  
)

export default component.exports